import { combineReducers } from 'redux'
import Auth from './auth/reducer';
import App from './app/reducer';
import Calendar from './calendar/reducer';
import Box from './box/reducer';
import Contacts from './contacts/reducer';

import Chat from './chat/reducers';
import DynamicChartComponent from './dynamicEchart/reducer';

import ThemeSwitcher from './themeSwitcher/reducer';
import Invoices from './invoice/reducer';
import LanguageSwitcher from './languageSwitcher/reducer';

import FirebaseAuth from './firebase_auth/reducer'
import CompanyReducers from "./company/reducers/currentCompany"
import CompanyUserReducer from "./current_user/reducer"

import CompanyLocationsReducers from "./company_location/reducers/company_locations"
import AssetReducers from "./assets/reducers/assets"
import CarrierUserReducers from "./users/reducers/carrier_users"
import ShipperUserReducers from "./shipper_users/reducers/users"
import DevicesReducers from "./devices/reducers/active_devices"
import BillingProfilesReduces from "./billing_profiles/reducers/billing_profiles"
import CompanyIntegrationsReducers from "./credential/reducers"
import ActiveAppIntegrationsReducers from "./integrations/reducers"

export const initialState = {}


const FB = combineReducers({
  company: CompanyReducers,
  companyUser: CompanyUserReducer,
  CompanyLocations: CompanyLocationsReducers,
  assets: AssetReducers,
  billingProfiles: BillingProfilesReduces,
  carrierUsers: CarrierUserReducers,
  shipperUsers: ShipperUserReducers,
  devices: DevicesReducers,
  companyIntegrations: CompanyIntegrationsReducers,
  activeAppIntegrations: ActiveAppIntegrationsReducers
})


export default {
  FB,
  Auth,
  FirebaseAuth,
  App,
  ThemeSwitcher,
  LanguageSwitcher,
  Calendar,
  Box,
  Contacts,
  Chat,
  DynamicChartComponent,
  Invoices,
};

